import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './GridCellContentOverflow.css';

export enum PaddingGridCellContentOverflow {
    XS = 'xs',
    S = 's',
    M = 'm'
}

export interface GridCellContentOverflowProps {
    sizeHiding?: PaddingGridCellContentOverflow;
}

export class GridCellContentOverflow extends React.Component<
    GridCellContentOverflowProps
> {
    render() {
        const {
            children,
            sizeHiding = PaddingGridCellContentOverflow.XS
        } = this.props;

        if (!children) {
            return null;
        }

        return (
            <div
                className={Bem.cls('grid-cell-content-overflow', 'wrapper', {
                    'size-hiding': sizeHiding
                })}
            >
                {children}
            </div>
        );
    }
}
